import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { User } from '@cropx-common/services/api-gateway/user.state';
import { LocalStorageService } from '@cropx-common/services/local-storage/LocalStorageService';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-page-500-error',
  templateUrl: './page-500-error.component.html',
  styleUrls: ['./page-500-error.component.scss'],
  imports: [RouterLink],
})
export class Page500ErrorComponent implements OnInit {
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private store = inject(Store);

  ngOnInit(): void {}

  onLogout(): void {
    this.localStorageService.clearAll();
    this.store.dispatch(new User.Logout());
    this.router.navigateByUrl('/login');
  }

  goToUrl(url: string): void {
    window.open(url, '_blank');
  }
}
